import { type QuizGenerateItem } from './type';

/**
 * AI 응답 항목의 정답 표면을 array<string> 으로 정규화한다.
 *
 * subjective multi-answer 도입 이후 서버는 `answers: string[]` (1~3개의
 * equivalent surface forms) 를 추가로 실어 보낸다. `answers` 가 비어있지
 * 않으면 그것을 사용하고, 없으면 legacy `answer` (string | string[]) 로
 * fallback — 신·구 서버 양쪽과 호환된다.
 *
 * 별도 파일로 분리한 이유: `useBuildAiQuiz.ts` 는 axios client (`AI_HTTP_CLIENT`)
 * 를 import 하므로 단위 테스트 환경에서 logger / fetch 의존성을 끌고 들어온다.
 * 순수 함수만 분리해서 test island 로 둔다.
 */
export const normalizeAnswers = (
  d: QuizGenerateItem & { answers?: string[] },
): string[] => {
  if (Array.isArray(d.answers) && d.answers.length > 0) {
    // 서버가 number 등 비-string 원소를 섞어 보낼 가능성 방어 — 원소를 string 으로 강제 변환.
    return d.answers.map(String);
  }
  if (Array.isArray(d.answer)) {
    // 위와 동일 — legacy `answer` 배열 분기에서도 원소 타입을 string 으로 통일.
    return d.answer.map(String);
  }
  // d.answer 가 nullish 인 비정상 응답 → 빈 배열로. `[undefined]` 를 흘려보내면
  // OX 분기의 `answers.map(a => a.toLowerCase())` 에서 TypeError 발생.
  if (d.answer == null) {
    return [];
  }
  return [String(d.answer)];
};
